var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wms-hero"},[_c('img',{staticClass:"wms-hero__banner",attrs:{"alt":"Tendencys","src":require("@/assets/images/auth/hero-wms.jpg")}})])
}]

export { render, staticRenderFns }